export const AUTH_ROUTES = [
    // 'logout',
    'codeverify',
    'newpassword',
    'resetpassword',
    'verify',
    'signup',
    'auth',
];
